import { USER_ACTION_TYPES } from "./user.action.types";
import { createAction } from "../../utils/reducer/reducer.util";

export const setCurrentUser = (user) =>
  createAction(USER_ACTION_TYPES.SET_CURRENT_USER, user);

/*
CHECK_USER_SESSION: 'user/CHECK_USER_SESSION',
  GOOGLE_SIGN_IN_START: 'user/GOOGLE_SIGN_IN_START',
  EMAIL_SIGN_IN_START: 'user/EMAIL_SIGN_IN_START',
  SIGN_IN_SUCCESS: 'user/SIGN_IN_SUCCESS',
  SIGN_IN_FAILURE: 'user/SIGN_IN_FAILURE'

*/

export const checkUserSession = () =>
  createAction(USER_ACTION_TYPES.CHECK_USER_SESSION);

export const googleSignInStart = () =>
  createAction(USER_ACTION_TYPES.GOOGLE_SIGN_IN_START);

export const signInSuccess = (user) =>
  createAction(USER_ACTION_TYPES.SIGN_IN_SUCCESS, user);

export const signInFailed = (error) =>
  createAction(USER_ACTION_TYPES.SIGN_IN_FAILED, error);

export const signOutStart = () =>
  createAction(USER_ACTION_TYPES.SIGN_OUT_START);

export const fetchCurrentUserScoreStart = () => createAction(USER_ACTION_TYPES.FETCH_CURRENT_USER_SCORE_START);

export const fetchCurrentUserScoreSuccess = (payload) => createAction(USER_ACTION_TYPES.FETCH_CURRENT_USER_SCORE_SUCCESS,payload);

export const fetchCurrentUserScoreFailure = (error) => createAction(USER_ACTION_TYPES.FETCH_CURRENT_USER_SCORE_FAILURE,error);

export const signOutSuccess = () =>
  createAction(USER_ACTION_TYPES.SIGN_OUT_SUCCESS);

export const signOutFailed = (error) =>
  createAction(USER_ACTION_TYPES.SIGN_OUT_FAILED, error);

  export const  registerUserStart = (payload) =>
  createAction(USER_ACTION_TYPES.REGISTER_USER_START, payload);

export const registerUserSuccess = (user) =>
  createAction(USER_ACTION_TYPES.REGISTER_USER_SUCCESS, user);

export const registerUserFailure = (error) =>
  createAction(USER_ACTION_TYPES.REGISTER_USER_FAILURE, error);
